import { Text } from '@doda/io-react/common';
import { useSelector } from 'react-redux';
import { PageTitle } from '@doda/io-react/pc';
import { validationMessagesSelector } from 'redux/features/jobList';
import { useAppSelector } from '@doda/common/src/redux/hooks';
import { jobListHeaderTextSelector } from 'redux/features/careerRecommendJobList';
import styles from './index.module.scss';

export const BodyHeader: React.FC = () => {
  const { isVisibleValidationMessages } = useSelector(
    validationMessagesSelector
  );
  const { title, explainText } = useAppSelector(jobListHeaderTextSelector);

  return (
    <div className={styles.careerRecommendJobList__contentsHeader}>
      {isVisibleValidationMessages ? (
        <PageTitle>求人情報の検索結果一覧</PageTitle>
      ) : (
        <>
          <PageTitle>{title}</PageTitle>
          <Text
            as="p"
            color="gray"
            size="12"
            weight="normal"
            className={styles.explainText}
          >
            {explainText}
          </Text>
        </>
      )}
    </div>
  );
};
